import axios, { AxiosResponse, AxiosError } from "axios";
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export const getOTP = (
  phone_number: any,
  country_code: any,
  from_register:any,
  successCallBack: (message: any) => void,
  errorCallBack: (errorMessage: any) => void
) => {
  const payload = {
    phone_number:phone_number,
    country_code:country_code,
    from_register:from_register
  };
  axios.post(`${global.api_url}/api/generate_otp`, payload)
  .then((response: AxiosResponse) => {
    successCallBack(response);
  })
  .catch((error: AxiosError) => {
    if (error.response?.status === 400) {
      errorCallBack(error);
    }
    else if  (error.response?.status === 401){
      localStorage.clear();
    }
    else{
      errorCallBack(error);
    }
  });
  }
  export const loginUser = (
    phone: string,
    country_code: string,
    language: string,
    successCallBack: (message: any) => void,
    errorCallBack: (errorMessage: any) => void,
    otp?: string,
    password?: string,
    fcm_token?: string
  ) => {        
    var cCode = country_code.replace("+", "");
    const payload = {
      phone: phone,
      country_code: cCode,
      password: password,
      language:language,
      otp: otp,
      fcm_token: fcm_token
    };
    axios.post(
      `${global.api_url}/api/login`,
      payload,
  
    )
    .then((response: AxiosResponse) => {
      if (response.status === 201) {
        successCallBack(response);
      } 
      else if (response.status === 200) {
        successCallBack(response);
      } 
    })
    .catch((error: AxiosError) => {
      if (error.response) {
        if (error.response.status === 400) {
          errorCallBack(error?.response?.data);
        } else if (error.response.status === 404){
          errorCallBack(error?.response?.data)
        }
        else if( error.response?.status === 409)
          {
            errorCallBack(error?.response?.data);
          }
        else if (error.response.status === 401) {
          localStorage.clear();
          toast.error("Login Expired.");
        }
      } 
      else {
        toast.error("Server Error");
      }
    });
  };
          